import { render } from "./TheVantagens.vue?vue&type=template&id=d80ccda8"
import script from "./TheVantagens.vue?vue&type=script&lang=js"
export * from "./TheVantagens.vue?vue&type=script&lang=js"

import "./TheVantagens.vue?vue&type=style&index=0&id=d80ccda8&lang=scss"

import exportComponent from "/home/runner/work/topnetms/topnetms/apps/topnetms_site_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__